export enum GiftCodeType {
    Order = 0,
    Shipping = 1,
    Product = 2
}
